<template>
	<div class="home">
      <div class='title'>首页</div>
      <div class='content'>
        <p>
          　　辽宁思凯科技股份有限公司成立于2009年，是中国首个智能燃气表、水表的发明者与产品供应商。公司致力于以新一代5G物联网与智能感知技术，重塑燃气、水等能源管理方式，提供智慧能源管理全套解决方案。公司为国内同行业物联网产品第一梯队企业，市场占有率与技术水平在华北、东北地区与辽宁省内排名第一，产品系辽宁首创的首台套产品。公司是国际上目前唯一同时拥有高、中、低压超声波燃气计量产品，并且通过MID欧盟认证的企业。
        </p>

      </div>
    </div>
</template>

<script>
	export default {
	  name: 'Home',
	  components: {

		  },
		  
	  props: {
	    // msg: String
	  }
	}
</script>

<style scoped>

  /* 在这里添加针对手机屏幕的样式 */
  .home {
    width: 82%;
    margin: 15vw auto;
    text-align: left;
  }

  .title {
    color: #333333;
    font-size: 5vw;
    margin-bottom: 20px;
  }

  .content {
    font-size: 4vw;
    color: #666;
    line-height: 6.75vw;
  }
  .content p {
    margin-bottom: 20px;
  }

  @media (min-width: 768px) {
  .home {
    width: 680px;
    margin: 80px auto;
  }
  .title {
    font-size: 30px;
    margin-bottom: 50px;
  }

  .content{
    font-size: 18px;
    line-height: 30px;
  }
}

@media (min-width: 960px) {
  .home{
    width: 900px;
  }

}

@media (min-width: 1200px) {
  .home {
    width: 1200px;
  }

}
</style>